import classnames from "classnames";
import { asField } from "informed";
import React, { Fragment } from "react";

import FormHelper from "./helper";

export const Input = asField(({ fieldState, fieldApi, append, ...props }) => {
  const { value } = fieldState;

  const { setValue, setTouched } = fieldApi;
  const {
    field,
    onChange,
    onBlur,
    faClass,
    initialValue,
    forwardedRef,
    ...rest
  } = props;
  return (
    <Fragment>
      <div className="form-group">
        {props.label && (
          <label htmlFor={field}>
            {faClass && <i className={faClass}></i>}
            {props.label}
          </label>
        )}
        <div className="input-group">
          {/* { "is-invalid": fieldState.error, "is-valid": fieldState.touched && !fieldState.error } */}
          <input
            {...rest}
            id={field}
            ref={forwardedRef}
            disabled={props?.disabled}
            // value={!value && value !== 0 ? "" : value}
            value={value||""}
            className={classnames("form-control", {
              "is-invalid": fieldState.error,
            })}
            onChange={(e) => {
              setValue(e.target.value);
              if (onChange) {
                onChange(e);
              }
            }}
            onBlur={(e) => {
              setTouched();
              if (onBlur) {
                onBlur(e);
              }
            }}
          />
          {append && (
            <div class="input-group-append">
              <span class="input-group-text" id="basic-addon2">
                {append}
              </span>
            </div>
          )}
        </div>
        {props.helper && <FormHelper content={props.helper} />}

        {fieldState.error ? (
          <div className="invalid-field">{fieldState.error}</div>
        ) : null}
      </div>
    </Fragment>
  );
});
